import { render } from "./form_2.vue?vue&type=template&id=fe6adf8e"
import script from "./form_2.vue?vue&type=script&lang=js"
export * from "./form_2.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/inspection_reports/forms/form_2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe6adf8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe6adf8e', __exports__)) {
    console.log('reload')
    api.reload('fe6adf8e', __exports__)
  }
  
  module.hot.accept("./form_2.vue?vue&type=template&id=fe6adf8e", () => {
    console.log('re-render')
    api.rerender('fe6adf8e', render)
  })

}


export default __exports__